import n from "../LabeledPromise/LabeledPromise.js";
class i extends n {
  _listeners;
  _progress;
  constructor(t) {
    const o = (e) => {
      if (e > 1 || e < 0)
        throw new TypeError(
          "The progress percentage should be a number between 0 and 1"
        );
      (async () => {
        if (await Promise.resolve(), !(e <= this._progress)) {
          this._progress = e;
          for (const r of this._listeners)
            r(e);
        }
      })();
    };
    super((e, r) => {
      t(
        (s) => {
          o(1), e(s);
        },
        r,
        (s) => {
          s !== 1 && o(s);
        }
      );
    }), Object.setPrototypeOf(this, i.prototype), this._listeners = /* @__PURE__ */ new Set(), this._progress = 0;
  }
  progress(t) {
    if (typeof t != "function")
      throw new TypeError(
        `Expected a \`Function\`, got \`${typeof t}\``
      );
    return this._listeners.add(t), this;
  }
}
export {
  i as default
};
//# sourceMappingURL=ProgressPromise.js.map
